import styled from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import { switchSizeOptions, switchStyleOptions } from './constants'

const Switch = styled.button`
  all: unset;
  ${({ size = switchSizeOptions.SMALL }) => switchStyleOptions[size]}
  background-color: ${colorsOptions.greys['grey-30']};
  border-radius: 64px;
  position: relative;
  &[data-state='checked'] {
    background-color: ${colorsOptions.docuToolsOrange.orange};
  }

  &:disabled {
    background-color: ${colorsOptions.greys['grey-30']};
    &[data-state='checked'] {
      background-color: ${colorsOptions.greys['grey-40']};
    }
  }
  outline: none;
`

const SwitchThumb = styled.span`
  all: unset;
  outline: none;
  display: block;
  ${({ size = switchSizeOptions.SMALL }) => switchStyleOptions[size].thumb}
  background-color: ${colorsOptions.greys.white};
  border-radius: 64px;
  border: 3px solid ${colorsOptions.greys['grey-70']};
  transition: transform ease-in-out 160ms;
  will-change: transform;
  &[data-state='checked'] {
    transform: translateX(
      ${({ size = switchSizeOptions.SMALL }) =>
        parseInt(switchStyleOptions[size].width) -
        parseInt(switchStyleOptions[size].thumb.width) -
        6}px
    );
    border-color: ${colorsOptions.docuToolsOrange.orange};
  }

  ${Switch}:disabled & {
    border-color: ${colorsOptions.greys['grey-30']};
    &[data-state='checked'] {
      border-color: ${colorsOptions.greys['grey-40']};
    }
  }
`

const SwitchSkeleton = styled.button`
  all: unset;
  ${({ size = switchSizeOptions.SMALL }) => switchStyleOptions[size]}
  background-color: ${colorsOptions.greys['grey-30']};
  border-radius: 64px;
  position: relative;
  &[data-state='checked'] {
    background-color: ${colorsOptions.greys['grey-40']};
  }
  outline: none;
`

const SwitchThumbSkeleton = styled.span`
  all: unset;
  outline: none;
  display: block;
  ${({ size = switchSizeOptions.SMALL }) => switchStyleOptions[size].thumb}
  background-color: ${colorsOptions.greys['grey-40']};
  border-radius: 64px;
  border: 3px solid ${colorsOptions.greys['grey-40']};

  &[data-state='checked'] {
    background-color: ${colorsOptions.greys['grey-50']};
    transform: translateX(
      ${({ size = switchSizeOptions.SMALL }) =>
        parseInt(switchStyleOptions[size].width) -
        parseInt(switchStyleOptions[size].thumb.width) -
        6}px
    );
    border-color: ${colorsOptions.greys['grey-50']};
  }
`

export { Switch, SwitchThumb, SwitchSkeleton, SwitchThumbSkeleton }
